import Store from '../store/store'

export default class Page {
    constructor(data, home = false) {
        this.id = (data.id != undefined) ? data.id : null
        this.name = data.name
        this.type = data.type

        this.icon = (data.icon != undefined) ? data.icon : this.getDefaultIcon(data.type)
        this.link = (data.link != undefined) ? data.link : this.getLink(home, data.name)
        this.search = (data.search != undefined) ? data.search : true
        this.hero = (data.hero != undefined) ? data.hero : false
        this.page_full_width = (data.page_full_width != undefined) ? data.page_full_width : false

        switch (data.type) {
            case 'beats':
                this.playlist_id = (data.playlist_id != undefined) ? data.playlist_id : null
                this.display_music = (data.display_music != undefined) ? (data.display_music == 'list' ? 'list' : 'block') : 'list'
                break

            case 'songs':
                this.playlist_id = (data.playlist_id != undefined) ? data.playlist_id : null
                this.display_music = (data.display_music != undefined) ? (data.display_music == 'list' ? 'list' : 'block') : 'block'
                break

            case 'soundkits':
                this.display_music = (data.display_music != undefined) ? (data.display_music == 'list' ? 'list' : 'block') : 'block'
                break

            case 'discover' :
                let sections = this.getDefaultDiscoverSections()

                this.featured = (data.featured != undefined) ? data.featured : sections.featured
                this.new = (data.new != undefined) ? data.new : sections.new
                this.trending = (data.trending != undefined) ? data.trending : sections.trending
                this.chart = (data.chart != undefined) ? data.chart : sections.chart
                this.soundkits = (data.soundkits != undefined) ? data.soundkits : sections.soundkits
                this.services = data.services ?? sections.services
                this.songs = (data.songs != undefined) ? data.songs : sections.songs
                this.licenses = (data.licenses != undefined) ? data.licenses : sections.licenses
                this.beattapes = data.beattapes != undefined ? data.beattapes: sections.beattapes


                break

            case 'charts' :
                this.size = (data.size != undefined) ? data.size : 100;
                break;
            case 'contact' :
                this.placeholders = data.placeholders ? data.placeholders : {
                    name: 'Enter your name',
                    email: 'Enter your email',
                    phone: 'Enter your phone',
                    message: 'Enter your message'
                };
                this.form_title = data.form_title || 'CONTACT ME!';
                break;
            case 'about' :
                this.background_image = (data.background_image !== undefined) ? data.background_image : null;
                this.background_image_requirements = (data.background_image_requirements !== undefined) ? data.background_image_requirements : {
                    'maxFileSize': 1,
                    'minHeight': 720,
                    'minWidth': 1080,
                };
                this.header_title = (data.header_title !== undefined) ? data.header_title : null;
                this.biography = (data.biography !== undefined) ? data.biography : null;
                this.social_profiles = (data.social_profiles !== undefined) ? data.social_profiles : false;
                break;
            case 'beattapes' :
                this.display_music = data.display_music === 'block' ? 'block' : 'list'
                this.display_selection = data.display_selection ?? false
                this.display_selection_list = data.display_selection_list ?? ''
                break;
            case 'services' :
                this.display_music = data.display_music === 'block' ? 'block' : 'list'
                this.display_selection = data.display_selection ?? false
                this.display_selection_list = data.display_selection_list ?? ''
                break;
        }

        this.error = false

    }

    setName(name) {
        // Replace leading and trailing white spaces
        let newName = name.replace(/^\s+|\s+$/g, "")
        // Replace multiple spaces with one
        newName = newName.replace(/\s\s+/g, " ");

        if (newName.length == 0) return

        this.name = newName

        Store.commit('pageNameChanged', true)
    }

    setIcon(icon) {
        this.icon.prefix = icon.prefix
        this.icon.name = icon.name
    }

    setLink(link) {
        this.link = link
    }

    setError(error) {
        this.error = error
    }

    getDefaultIcon(type) {
        let icon;

        switch (type) {
            case "discover":
                icon = {
                    prefix: "fas",
                    name: "play-circle"
                }
                break
            case "beats":
                icon = {
                    prefix: "fas",
                    name: "binoculars"
                }
                break
            case "charts":
                icon = {
                    prefix: "fas",
                    name: "chart-line"
                }
                break
            case "soundkits":
                icon = {
                    prefix: "fas",
                    name: "microphone"
                }
                break
            case "services":
                icon = {
                    prefix: 'fas',
                    name: 'people-arrows'
                }
                break
            case "licenses":
                icon = {
                    prefix: "fas",
                    name: "list-ui"
                }
                break
            case "contact":
                icon = {
                    prefix: "fas",
                    name: "comment-dots"
                }
                break
            case "about":
                icon = {
                    prefix: "fas",
                    name: "info-circle"
                };
                break;
            case "beattapes":
                icon = {
                    prefix: 'fas',
                    name: 'list-music'
                }
                break
            default:
                icon = {
                    prefix: "fas",
                    name: "binoculars"
                }
        }

        return icon
    }

    getLink(home, name) {
        if (home) {
            return "/"
        }

        let link = name.toLowerCase().replace(/ /g, "-")
        return "/" + link
    }

    getDefaultDiscoverSections() {
        return {
            featured: {
                primary: {
                    show: true,
                    items: []
                },
                secondary: {
                    show: true,
                    items: []
                }
            },
            new: {
                show: true,
                display: 'blocks'
            },
            trending: {
                show: true
            },
            chart: {
                show: true
            },
            soundkits: {
                show: true,
                items: []
            },
            services: {
                show: true,
                items: []
            },
            licenses: {
                show: true
            },
            beattapes: {
                show: true,
                items: []
            },
        }
    }

    showSection(section, subsection = false) {

        let sectionToEdit = this[section]

        if (subsection) {
            sectionToEdit = sectionToEdit[subsection]
        }

        if (sectionToEdit.show != undefined) {
            sectionToEdit.show = true
        }
    }

    hideSection(section, subsection = false) {
        let sectionToEdit = this[section]

        if (subsection) {
            sectionToEdit = sectionToEdit[subsection]
        }

        if (sectionToEdit.show != undefined) {
            sectionToEdit.show = false
        }
    }

    changeSectionValue(newVal, param, section, subsection = false) {
        let sectionToEdit = this[section]

        if (subsection) {
            sectionToEdit = sectionToEdit[subsection]
        }

        sectionToEdit[param] = newVal
    }

    setPlaylist(value) {
        if (value) {
            return this.playlist_id = parseInt(value)
        }
        return this.playlist_id = value
    }

    changeParameterValue(newVal, param) {
        this[param] = newVal
    }

}
